export default __webpack_public_path__ + "d15c86d7450423af53392030249cafe0.jpg";